'use strict';

/*
Handles the display of the compare selects, generated via XSL in Vehicle-Compare-Association.xsl
and some bits in the content section of Vehicle-Compare-Simple-Skin.xsl
(including the TSS section slideshow on compare pages)
*/
define('features/compare/compare-association',[
  'jquery',
  'components/slicker',
  'lib/util/debounce',
  'disclaimers',
  'responsive',
  'bat',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',

  // side effect includes
  'dropkick'
], function (
  $,
  Slicker,
  debounce,
  disclaimers,
  responsive,
  bat,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  // Holy smokes... we build all this initial data from the URL of the page.
  // which we don't HAVE to be.
  // The vehicle association DCR does contain a valid series along with it
  function __vehiclesFromUrl() {
    var curHref = window.location.pathname;
    var curPage = curHref.substr(curHref.lastIndexOf('/') + 1);
    var toyVeh;
    var compVeh;
    curPage = curPage.replace('.page', '');
    curPage = curPage.split('-');
    toyVeh = curPage[1];
    compVeh = curPage[2];

    // BAT-2745: SPECIAL CASE FOR C-HR
    if (curPage.length > 3) {
      toyVeh = curPage[1] + '-' + curPage[2];
      compVeh = curPage[3];
    }
    return [toyVeh, compVeh];
  }

  function __toySeries() {
    return __vehiclesFromUrl()[0].toLowerCase();
  }

  function __compSeries() {
    return __vehiclesFromUrl()[1];
  }

  function __toyYear() {
    var curHref = window.location.pathname;
    var curPage = curHref.substr(curHref.lastIndexOf('/') + 1);
    curPage = curPage.replace('.page', '');
    curPage = curPage.split('-');
    return '20' + curPage[0];
  }

  var CompareAssociation = function (el, config) {
    this._el = $(el);
    this._config = config;
    this.initialize.apply(this, arguments);
  };

  $.extend(CompareAssociation.prototype, {
    initialize: function (el, config) { // eslint-disable-line no-unused-vars
      console.log('CompareAssociation initialize: ', this); // eslint-disable-line no-console
    },

    load: function () {
      this.$el = $(this._el);
      // listen for PageCache compare table that adds the "real" data?
      // but then how to remove scroller on compare table multi?

      // we setup series and competitor "data" this way
      // so we dont need to do it over and over again for all the spots we need this "data"
      // I say "data", because its all built from the URL, which is astounding!
      this.series = { series_code: __toySeries(), year: __toyYear() };
      this.comp = { model: __compSeries() };
      this.drawSelects();
      this.slideshow();
      this.pageDisclaimers();
      this.analytics();
      bat.util.loader.hideLoader();
      this.focusTable();
      this.canonLinks();
    },

    drawSelects: function () {
      var $userComp = this.$el;
      var $userCompToyTrim = $userComp.find('#js-compare-toyota');
      var $userCompOtherTrim = $userComp.find('#js-compare-other');
      var $userCompSubmit = $userComp.find('.btn');
      var toyVeh = this.series.series_code;
      var compVeh = this.comp.model;
      var curPage = this.series.year;

      // update the Toyota select to show the proper, currently selected option
      var currentToySelect = $('span[data-series="' + toyVeh + '"][data-title*="' + curPage + '"]').data('title');
      if (!currentToySelect) {
        // corolla-hatchback, maybe-more-gosh-darn-it
        toyVeh = toyVeh.replace('-', '');
        currentToySelect = $('span[data-series="' + toyVeh + '"][data-title*="' + curPage + '"]').data('title');
      }
      $userCompToyTrim.find('option[value="' + currentToySelect + '"]').prop('selected', true);
      $('#js-title-toyota').text(currentToySelect + ' ');

      // get the value of currently selected option

      // Update the competitors select based on the value of the
      // currently selected toyota trim select
      var currentToy = $userCompToyTrim.val();
      var currentToyRelated = $('span[data-title="' + currentToy + '"]').html();
      $userCompOtherTrim.html(currentToyRelated);

      // update the competitors select to show the proper, currently selected option (based on page title)
      $('#js-compare-other option').each(function () {
        var curVal = $(this).val();
        if (curVal.indexOf(compVeh) > -1) {
          $(this).prop('selected', true);
          $('#js-title-other').text(' ' + $(this).data('title'));
        }
      });

      // draw custom selects
      $userCompToyTrim.dropkick({ mobile: true });
      $userCompOtherTrim.dropkick({ mobile: true });
      $('.js-row-selects').addClass('is-loaded');
      $('.cv-title').animate({ opacity: 1 });

      $userCompOtherTrim.on('change', function () {
        var $this = $(this);
        if ($this.val() === '') {
          $this.addClass('ui-state-error');
        } else {
          $this.removeClass('ui-state-error');
        }
        $userCompOtherTrim.dropkick('refresh');
      });

      // change events on competitor select
      $userCompToyTrim.on('change', function () {
        // empty competitors trim
        $userCompOtherTrim.empty();
        var $this = $(this);

        // get this selected Toyota trim
        // and grab all the associated competitors trim
        // we'll use those to update the competitors select
        var thisTrim = $this.val();
        var assTrimsHtml = $userComp.find('span[data-title="' + thisTrim + '"]').html();
        // find associate trims, based on thisTrim

        // append these as options to $userCompOtherTrim (comparable trims)
        // and refresh the custom select
        $userCompOtherTrim.append(assTrimsHtml).dropkick('refresh');
      });

      // on click of submit button, go to compare page
      $userCompSubmit.on('click', function (e) {
        e.preventDefault();
        var $selectedOption = $userCompOtherTrim.find(':selected');

        // Make sure a competitors trim is selected
        if ($selectedOption.val() === '') {
          $userCompOtherTrim.addClass('ui-state-error');
          $userCompOtherTrim.dropkick('refresh');
          return;
        }

        bat.util.loader.showLoader();
        var comparePage = $selectedOption.val();
        $userCompSubmit.attr('href', comparePage);
        window.location.href = comparePage;
      });
    },

    // Is this still a thing? Wasn't TSS moved to its own component?
    // safety Sense, slideshow (mobile only), Vehicle-Compare-Simple-Skin.xsl
    slideshow: function () {
      var self = this;
      self.imageSlides = new Slicker({
        $slider: $('.tss-slideshow .carousel-inner'),
        slickOptions: {
          mobileFirst: true,
          fade: false,
          slide: 'li',
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          arrows: true,
          dots: true,
          paddingBottom: 40,
          // Can't use tablet here, need to use slicks native responsive here
          responsive: [{
            breakpoint: 767,
            settings: 'unslick'
          }]
        }
      });
      self.slideshowListen();
    },

    slideshowListen: function () {
      var self = this;
      self.imageSlides.$slider.on('destroy', function (ev, slick) {
        self.reinit = debounce(function () {
          // slick.activeBreakpoint will tell us the breakpoint at which the carousel was destroyed
          if (slick.activeBreakpoint < window.innerWidth) {
            return;
          }
          self.slideshow();
          $(window).off('resize', self.reinit);
        }, 1000);
        $(window).on('resize', self.reinit);
      });
    },

    pageDisclaimers: function () {
      // TODO: Change disclaimers to emit a ready via PageCache?
      $(window).on('loaded', function () {
        disclaimers.addLocalDisclaimers('.cv-intro', '.js-disclaimer-local');
        disclaimers.addLocalDisclaimers('.cv-tss', '.js-disclaimer-local');
      });
    },

    focusTable: function () {
      if (responsive() === 'sm') {
        $('body, html').animate({
          scrollTop: $('.cv-compare-table').offset().top
        }, 700);
      }
    },

    canonLinks: function () {
      $('head').append('<link rel="canonical" href="https://www.buyatoyota.com' + window.location.pathname + '" />');
    },

    analytics: function () {
      // our data is so poor, we grab the competitor year like this
      this.comp.year = $('#js-compare-other option:selected')
        .data('title').split(' ')[0];
      anAddContext(
        this.$el,
        blocks.sectionBlock('compare select'),
        blocks.seriesBlock(this.series),
        blocks.compareBlock(this.comp)
      );
      anPageLoad(this.$el);
      anClicks(this.$el);
    }

  });

  return CompareAssociation;
});

